import React, { useEffect, useState } from 'react';
import VerificationPopup from '../modals/VerificationPopup';
import styles from '../../styles/newFeature.module.css';
import content from '../../language/ENGLISH.json'
import { HeroSection, MarqueeComponentHomePage, ParksFeaturesSection, QueueBusterExperienceCentersSection,DownloadBrochureWonderla, StackContainers, StackSkeleton, NewMarqueeComponentHomePageIndia, IAAPISection, ThemeParkIndustryFeaturesSection, ThemeParkReviewsSection } from '../qbStrap';
import { ClientsArr1, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import FAQ_mobile from '../Industry/FAQ_mobile';
import FrequentQuestions from '../homePage/FrequentQuestions';
import MobilePDBanner from '../common/MobilePDBanner';
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner';
import TestimonialSection from '../common/TestimonialSection';
import MobileTestimonialSection from '../common/MobileTestimonialSection';
import ThreeStepForm from '../common/ThreeStepForm';
import Image from 'next/image';
import OutletFeatures from '../common/OutletFeatures';
import { useRouter } from 'next/router';

const ThemePark = () => {
    const { commonMarqueTitle } = getTitleContent();
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);
    const [heroReadMore, setHeroReadMore] = useState(false);
    const router = useRouter()

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const features = [
        {
            id: 1,
            image: "/assets/outlet/themePark/pos.webp",
            tag: "Point Of Sale",
            icon: "/assets/groceries/kirana/POS.svg",
            title: "Super Fast Billing Software For Guest Entries",
            desc: <>QueueBuster POS management software is the backbone of your amusement park’s operations, powering super-fast billing and hassle-free guest entry at gates. From ticketing counters to entry turnstiles, our system ensures lightning-quick transactions for tickets, refreshments, and merchandise, while maintaining complete accuracy and transparency. <br />
            With an intuitive, mobile-first interface, staff can manage ticket scanning, guest verification, billing, and services directly through handheld POS devices. Less training time, fewer queues, and a smoother experience for every visitor walking into your park.</>,
            tagColor: "#8AE4F6",
            bgColor: "#8ae4f626",
            stackColor1: "#D6F6FC",
            stackColor2: "#B0EFFC",
            stackColor3: "#8AE4F6",
            stackColor4: "#70D3E6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "10rem",
            meHeight: "28rem",
            btnText: "Contact Sales",
            points: [
                <>
                   Fast processing of high-volume ticket sales and guest entries, keep the lines moving effortlessly.
                </>,
                <>
                    Instant QR / barcode scanning at gates for quick and secure guest verification.
                </>,
                <>
                   Easy staff training and simple POS operation across billing counters and entry points.
                </>,
                <>Accept every payment mode, from cash to cards to complete contactless payments.</>
            ],
        },
        {
            id: 2,
            image: "/assets/outlet/themePark/online-ticket.webp",
            tag: "On-The-Go Ticketing",
            icon: "/assets/outlet/iceCreamOutlet/onlineticket-parkpos.svg",
            title: "Effortless Ticket Management for Every Guest",
            desc: <>Give your guests the freedom to purchase tickets instantly with QueueBuster’s On-The-Go Ticketing feature. Whether they’re on the way to the park or just outside the gate, guests can buy tickets in seconds, reducing queues, preventing entry-point congestion, and improving overall guest flow. <br />
            This feature connects seamlessly with your POS, ensuring that both online and offline ticket sales stay perfectly synchronized in real time.</>,
            tagColor: "#FFBA00",
            bgColor: "#fff7e2",
            stackColor1: "#FEF8EB",
            stackColor2: "#FEEAC0",
            stackColor3: "#FFD579",
            stackColor4: "#FFC23E",
            sHeight: "10rem",
            eHeight: "26rem",
            msHeight: "15rem",
            meHeight: "41rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Sell tickets to guests at any time and from any location.
                </>,
                <>
                    Make admission faster due to prepurchased tickets.
                </>,
                <>
                    Sync online ticket sales into the onsite operations seamlessly.
                </>,
                <>Centralized, real-time validation across entry points.</>
            ],
        },
        // {
        //     id: 3,
        //     image: "/assets/outlet/themePark/cashless.webp",
        //     tag: "Cashless Wallets Integration",
        //     icon: "/assets/outlet/iceCreamOutlet/onlinewallet.svg",
        //     title: "Effortless Payments for Rides, Food, and More",
        //     desc: "Cashless wallets enhance the visitor experience by loading money into a digital wallet associated with the visitor's entry ticket or wristband for money storage. This functionality speeds up transactions and avoids the necessity of carrying cash, and therefore guests can enjoy the park hassle-free from money or cards.",
        //     tagColor: "#EEC9FF",
        //     bgColor: "#fcf6ff",
        //     stackColor1: "#FCF7FF",
        //     stackColor2: "#F4E1FF",
        //     stackColor3: "#EEC9FF",
        //     stackColor4: "#E4ADFE",
        //     sHeight: "10rem",
        //     eHeight: "29rem",
        //     msHeight: "17rem",
        //     meHeight: "45rem",
        //     btnText: "Talk	to an expert",
        //     points: [
        //         <>
        //             Guests pay for rides, food, and merchandise simply by tapping.
        //         </>,
        //         <>
        //             Digital wallet integration reduces the likelihood of money being stolen or lost.
        //         </>,
        //         <>
        //             Faster and more convenient transactions will increase sales.
        //         </>,
        //     ],
        // },
        // {
        //     id: 4,
        //     image: "/assets/outlet/themePark/DailySalesReport.webp",
        //     tag: "Daily Sales Report",
        //     icon: "/assets/outlet/iceCreamOutlet/report-pos.svg",
        //     title: "Track Daily Performance by Department",
        //     desc: "Keep up with the performance of your park in QueueBuster POS system detailed Daily Sales Reports. It gives users an in-depth view of the daily revenues, sales trends, and operational efficiency. This is crucial data for making informed decisions while looking to analyze performance, plan promotions, or manage staff.",
        //     tagColor: "#4EEAC2",
        //     bgColor: "#e6fff9",
        //     stackColor1: "#C8F4E9",
        //     stackColor2: "#9EE9D6",
        //     stackColor3: "#4EEAC2",
        //     stackColor4: "#47DDB6",
        //     sHeight: "7rem",
        //     eHeight: "20rem",
        //     msHeight: "7rem",
        //     meHeight: "23rem",
        //     btnText: "Contact Sales",
        //     points: [
        //         <>
        //             Monitor sales daily by department.
        //         </>,
        //         <>
        //             Spot trends to even better make for operational and marketing efficiencies.
        //         </>,
        //         <>
        //             Make data-driven decisions towards improving the management of parks.
        //         </>,
        //     ],
        // },
        {
            id: 5,
            image: "/assets/outlet/themePark/Smarter&Cashless.webp",
            tag: "RFID Wearables & Scanners",
            icon: "/assets/outlet/themePark/rfid1.svg",
            title: "Smarter, Cashless, and Personalized Park Experience",
            desc: "Empower your guests with RFID-enabled scanners. These wearables simplify cashless transactions across rides, food stalls, and retail shops, making payments effortless and secure. Beyond convenience, they unlock personalized experiences by tracking guest preferences and ride histories, helping you deliver unforgettable moments every visit.",
            tagColor: "#FFC3C3",
            bgColor: "#FFF3F3",
            stackColor1: "#FFF5F5",
            stackColor2: "#FFEBEB",
            stackColor3: "#FFDBDB",
            stackColor4: "#FFC3C3",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Enable seamless cashless payments across the park.
                </>,
                <>
                    Personalize guest journeys with real-time data insights.
                </>,
                <>
                   Ensure quick, contactless transactions at every touchpoint.
                </>,
            ],
        },
        {
            id: 6,
            image: "/assets/outlet/themePark/UnifiedBookings.webp",
            tag: "Omnichannel Booking Engine",
            icon: "/assets/outlet/themePark/Omnichannel.svg",
            title: "Unified Bookings Across Every Channel",
            desc: "Simplify and centralize all your park bookings with QueueBuster’s Omnichannel Booking Engine. Whether tickets are sold through walk-ins, OTAs, your website, or distributor networks, every sale syncs seamlessly in real time. This ensures accurate guest data, eliminates double bookings, and gives your team a unified view of every channel on a single dashboard.",
            tagColor: "#C9F6FF",
            bgColor: "#8AE4F626",
            stackColor1: "#D6F6FC",
            stackColor2: "#B0EFFC",
            stackColor3: "#8AE4F6",
            stackColor4: "#70D3E6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Manage walk-in, online, and partner bookings from one platform.
                </>,
                <>
                    Get real-time synchronization across all sales channels.
                </>,
                <>
                   Reduce manual errors and improve overall guest coordination.
                </>,
            ],
        },
        {
            id: 7,
            image: "/assets/outlet/themePark/SeamlessData.webp",
            tag: "ERP Integration & Data Management",
            icon: "/assets/outlet/themePark/erp.svg",
            title: "Unified ERP Sync & Master Data Management for Park Operations",
            desc: <>Integrate QueueBuster effortlessly with your existing ERP system to keep every business function in perfect sync. From ticket sales to inventory movement and financial transactions, all data updates in real time. QueueBuster also streamlines Master Data Management, ensuring consistent product, pricing, category, user data across all systems without duplication or mismatch.<br />
            This unified ecosystem enhances operational transparency, reduces manual effort, and empowers smarter, data-driven decision-making for park management.</>,
            tagColor: "#FFBA00",
            bgColor: "#F8D37826",
            stackColor1: "#FEF8EB",
            stackColor2: "#FEEAC0",
            stackColor3: "#FFD579",
            stackColor4: "#FFC23E",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Achieve real-time sync between sales, stock, and finance.
                </>,
                <>
                Eliminate manual data entry and reconciliation errors.
                </>,
                <>
                Gain complete visibility into operations and performance.
                </>,
            ],
        },
        {
            id: 8,
            image: "/assets/outlet/themePark/CashlessWalletsIntegration.webp",
            tag: "F&B Operations",
            icon: "/assets/outlet/themePark/Food.svg",
            title: "Food & Beverage Management",
            desc: "QueueBuster POS simplifies F&B operations across your amusement park. Unified billing and centralized inventory keep everything running smoothly, while real-time order tracking ensures faster service and reduced wait times. With automated stock updates and performance reports, managing multiple counters becomes effortless and efficient. Designed for staff ease and guest satisfaction alike.",
            tagColor: "#EEC9FF",
            bgColor: "#EEC9FF26",
            stackColor1: "#FCF7FF",
            stackColor2: "#F4E1FF",
            stackColor3: "#EEC9FF",
            stackColor4: "#E4ADFE",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Unified billing, inventory, and order management across outlets.
                </>,
                <>
                    Real-time tracking for faster service and reduced errors.
                </>,
                <>
                   Simplified control over multiple F&B counters in one system.
                </>,
            ],
        },
        

    ];
    const ClientsArr = [
        { imgSrc: "/assets/HomeLanding/QBIcons/wonderla.svg", height:"14rem",width:"20rem", altText: "Wonderla" },
        { imgSrc: "/assets/HomeLanding/QBIcons/shivalaya1.svg", height:"14rem",width:"20rem", altText: "Shivalaya 1" },
        { imgSrc: "/assets/HomeLanding/QBIcons/dizzee.png", height:"9.2rem",width:"18rem", altText: "Dizzee" },
    ]
    const ClientsArrMobile = [

        { imgSrc: "/assets/HomeLanding/QBIcons/dizzee.png", height:"8rem",width:"17rem", altText: "Dizzee" },
        { imgSrc: "/assets/HomeLanding/QBIcons/wonderla.svg", height:"8rem",width:"18rem", altText: "Wonderla" },
        { imgSrc: "/assets/HomeLanding/QBIcons/shivalaya1.svg", height:"8rem",width:"18rem", altText: "Shivalaya 1" },
    ]

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is the main advantage of using the QueueBuster Advanced POS System in a Amusement Park?
                </span>
            ),
            des: "The QueueBuster Advanced POS System gives a wide array of benefits that enable Amusement Parks to simplify and automate various park operations, such as ticket sales, inventory management, and cashless transactions so that your park runs at an increased pace. Notably, it reduces wait time, which keeps an eye on ride capacities and optimizes guest flow with features like Backlog Management. Fast and error-free transactions by this system will improve guest treatment. Moreover, you will receive a detailed report about how well your park is performing with the Daily Sales Report so that all your decisions regarding better operational efficiency and increased revenue are made based on data. Therefore, in the broad sense, QueueBuster assures a guest-friendly, operationally sound Amusement Park.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How Backlog Management feature will help in improving guest satisfaction?
                </span>
            ),
            des: "The main essence of Backlog Management is to keep the smoothness and enjoyment of the experience for the guests. It comforts the management of the park by providing real-time information on the capacities of the ride, the guest numbers, and the wait periods. This way, it assists in predicting and handling queues, avoiding congestion, thus enabling spending less time in queues and more at attractions that make them feel wonderful. All of this leads to increased satisfaction with the guests since shorter wait times mean happier and more enthusiastic visitors, who will certainly come back. This function also allows for general guest flow optimization in the park, with no crowding and all resources being best utilized.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can QueueBuster POS manage high transaction volumes at peak times?
                </span>
            ),
            des: "Yes, even at peak hours, QueueBuster POS can manage heavy volumes of transactions. Its robust architecture makes transactions quick and accurate for ticket sales; food, beverage, and merchandise purchases; among others. Such capability is important in a Amusement Park setting because there will be a huge number of guests making transactions simultaneously. This also accepts so many kinds of payments, such as in cash, credit and debit cards, and now contactless payments; this helps cut down time on the part of any guest when a purchase is made, thereby smoothening the operations of the staff. Furthermore, the user-friendly interface minimizes the learning curve of staff and major mistakes while handling transactions, even when it is in a busy period.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the Online Ticketing feature interface with the on-site POS system?
                </span>
            ),
            des: "The Online Ticketing module is seamlessly interfaced with the on-site QueueBuster POS. This means all sales data is synchronized in real time. An event ticket bought online immediately updates the on-site POS to ensure that there is no overbooking at the event and that all numbers for tracking are accurate. This is further streamlined at the gates of the park, whereby people with pre-bought tickets can scan them, thus allowing quicker entry therefore mitigating congestion and other delays. In addition, it gives valuable information about the sales of online and on-site tickets, with which the management of the park makes proper decisions about marketing, promotions, and capacity planning.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How has security been handled in the Cashless Wallets integration?
                </span>
            ),
            des: "The integration of Cashless Wallets in QueueBuster POS is designed with multiple layers of security for securing both guest funds and personal information. Each of these digital wallets is linked through a guest's entrance ticket or wristband. It will make sure only the owner will be able to do money operations on those funds. The system uses encryption and tokenization to keep the transactions safe from fraud and theft. More so, if a wristband or ticket gets lost, the wallet could easily be turned off and the remaining balance transferred to a new one. In so doing, it delivers not just enhanced security but additional peace of mind to each guest, freeing them from worry about cash or cards.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Explain, with examples, how the feature Daily Sales Report supports the management of operations in the park.
                </span>
            ),
            des: "The Daily Sales Report features of the QueueBuster POS system provide information and support up to the granularity of the park's financial performance and operations. It follows the earnings per day, patterns of sales, and effectiveness of the departments in question, giving an overview of the performance of the park. This data can be fully utilized in the position of the park manager to somehow analyze which areas are doing well and which others require adjustment. For instance, the attraction areas—areas that are picking up more revenue—and areas in which sales are suffering that would otherwise be boosted by a promotion. This data can further be used for determining the optimal staffing level, event planning in the future, and any strategic decisions that go towards the achievement of the goals in the park. This level of reporting warrants that all management is up to date and can react swiftly to any issue or opportunity.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Is the QueueBuster POS system scalable for large Amusement Parks?
                </span>
            ),
            des: "Absolutely. With the QueueBuster POS, every small-sized and large-sized Amusement Park installation can be covered with ease. If it is one location or multiple parks, the system is designed to serve a huge number of transactions, extensive inventory, and numerous guest interactions with no compromise in speed or accuracy. This can be done because the architecture is cloud-based and is inherently expandable. The system is going to expand with you as you turn your park into a bigger one, increasing your need for terminals, possibly new attractions, and operational complexity. This will make your QueueBuster Amusement Park, with your expanded terminal numbers and new attractions, provide the tools needed to manage this effectively.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster support inventory management in a Amusement Park setting?
                </span>
            ),
            des: "QueueBuster POS brings with it advanced inventory management capabilities, a must-have for themed parks with a variety of stocks that include foods, beverages, novelties, and ride accessories. Levels of inventory are always real-time, with preset alerts to automatically flag you on slow-moving items or low stock. Auto-reorder so your park always has the right products available to meet the requirements of your visitors. It can also track inventory in multiple locations across the park, enabling proper centralized management and coordination with ease. Besides this kind of inventory control, waste can be drastically minimized, good stock levels can be maintained, and most items are readily available to park patrons at any given time.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How user-friendly is the QueueBuster POS system for park staff?
                </span>
            ),
            des: "The point of sale of the QueueBuster is designed in such a way that it is user-friendly for staff working in the park. The intuitive interface gives it built-in potential to need minimum training so that new employees can pick up the system easily. Thus, new employees are unlikely to have difficulty using the system since the processing of transactions is fast, multiple payment methods are easily accessed, and on-screen clear instructions facilitate effective service delivery. This feature also bears the options customizable according to your park's own requirements, which goes far in streamlining operations. This user-friendly design reduces errors, increases staff efficiency, and ultimately enhances the guest's experience.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What kind of customer service options are available for those using QueueBuster POS?
                </span>
            ),
            des: "QueueBuster offers complete customer service such that your Amusement Park's POS system remains smooth. Our customer support team is open 24 hours a day, 7 days a week. Our technical team is competent and will be on standby to assist in any way, at any hour of the day, either remotely or on-site, ensuring your problems are solved at the earliest time possible. We also provide training resources and documentation, enabling your staff to be as knowledgeable as feasibly necessary about the system. With the customer support available from QueueBuster, you can be ensured at all times that your POS system will be working in perfect shape, while you are left to give your guests the finest experience ever.",
            id: 10,
            activeIndex: 0,
        },
    ];


    const parksFeatures = [
        {
            id: 1,
            image: "/assets/outlet/themePark/KidsPlayArea.webp",
            title: "Kids Play Area",
        },
        {
            id: 2,
            image: "/assets/outlet/themePark/Restaurants.webp",
            title: "Restaurants",
        },
        {
            id: 3,
            image: "/assets/outlet/themePark/FoodCourts.webp",
            title: "Food Courts",
        },
        {
            id: 4,
            image: "/assets/outlet/themePark/VR-AR.webp",
            title: <>VR/AR <br />Experience Centers</>,
        },
        {
            id: 5,
            image: "/assets/outlet/themePark/Family.webp",
            title:<>Family <br />Entertainment Centers</>,
        },
        {
            id: 6,
            image: "/assets/outlet/themePark/Event&PartyZones.webp",
            title: "Event & Party Zones",
        },
        {
            id: 7,
            image: "/assets/outlet/themePark/Spa&RelaxationZone.webp",
            title: "Spa & Relaxation Zone",
        },
        
    ]

    const themeParkClients = [
        { imgSrc: "/assets/HomeLanding/QBIcons/shivalaya1.svg", altText: "Shivalaya 1" },
        { imgSrc: "/assets/themePark_icons/dizzie.svg", altText: "Dizzee World" },
        { imgSrc: "/assets/themePark_icons/sgnp.svg", altText: "SGNP" },
        { imgSrc: "/assets/themePark_icons/kochui.svg",  altText: "Kochi" },
        { imgSrc: "/assets/themePark_icons/escape.svg",  altText: "Escape Water Park" },
        { imgSrc: "/assets/themePark_icons/vedvan.svg",  altText: "Vedvan" },
        { imgSrc: "/assets/themePark_icons/bekal.svg", altText: "Bekal" },
        { imgSrc: "/assets/themePark_icons/wtfun.svg", altText: "WTFun" },
        { imgSrc: "/assets/themePark_icons/tamil.svg",  altText: "Tamil Nadu Tourism" },
        { imgSrc: "/assets/themePark_icons/telangana.svg",  altText: "Telangana Tourism" },
        { imgSrc: "/assets/themePark_icons/odisha.svg",  altText: "Odisha Tourism" },
        { imgSrc: "/assets/themePark_icons/bengaluru.svg",  altText: "Bengaluru Tourism" },
        { imgSrc: "/assets/themePark_icons/mojoland.svg",  altText: "Mojoland" },
        { imgSrc: "/assets/themePark_icons/hpca.svg",  altText: "HPCA" },
    ]

    const marqueeClientsArr = mobileView
        ? themeParkClients.map((c) => ({ ...c, height: "8rem", width: "15rem" }))
        : themeParkClients.map((c) => ({ ...c, height: "10rem", width: "15rem" }))

    return (
        <div>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            {
                mobileView ?
                    <div className={styles.hero_section} style={{ backgroundImage: "url('/assets/outlet/themePark/mobile-hero-img.webp')" }}>
                        <div>
                            <h1>
                                <span>QueueBuster Advanced</span><span></span>
                                <span>&nbsp; POS System for Amusement Park Operations</span>
                            </h1>
                            <p style={{ maxHeight: heroReadMore ? "20rem" : "5rem", overflow: heroReadMore ? 'auto' : "hidden", transition: "1s", marginTop: "2rem" }}>Simplify and automate your Amusement Park into a seamless, efficient, and guest-friendly destination with the QueueBuster Advanced POS System. Designed specifically for the dynamic needs of Amusement Parks, our cutting-edge POS solution streamlines everything from ticket sales and inventory management to cashless transactions and real-time reporting. </p>
                            <p className={styles.read_more} onClick={() => setHeroReadMore(!heroReadMore)}>{heroReadMore ? "Read Less" : "Read More"}</p>
                            <div className={styles.btn_container}>
                                <button className={styles.solid_btn} onClick={() => router.push('/contact-form')}>Contact Sales</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.sections}>
                        <HeroSection
                            style={{ font: "normal normal bold 4rem/5.5rem Inter", color: "#fff" }}
                            backgroundImg="/assets/outlet/themePark/hero-img.webp"
                            heading={<>QueueBuster Advanced <br /></>}
                            staticHeading={<>POS System for Amusement Park Operations</>}
                            description={"Simplify and automate your Amusement Park into a seamless, efficient, and guest-friendly destination with the QueueBuster Advanced POS System. Designed specifically for the dynamic needs of Amusement Parks, our cutting-edge POS solution streamlines everything from ticket sales and inventory management to cashless transactions and real-time reporting. "}
                            solidBtnText={"Contact Sales"}
                            textContainerStyle={{ width: "55%" }}
                            setDemoModal={setDemoModal}
                        />
                    </div>
            }

            {/* <div className={styles.marquee_section}>
                 
                <ThemeParkIndustryFeaturesSection />
            </div> */}

       <div style={ mobileView ? { margin: "0rem", position: "relative", zIndex:1 } : { margin: "0rem", position: "relative", zIndex:1 }}>
                <NewMarqueeComponentHomePageIndia
                    ClientsArr={marqueeClientsArr} speed={100} pauseOnHover={true}
                    style={{
                        width: "100%",
                        backgroundColor: "transparent",
                        display: "flex",
                        justifyContent: "center",
                        margin: "2rem auto", 
                    }}
                    
                />
                </div>

            <div>
                <IAAPISection mobileView={mobileView} />
            </div>

            <div className={styles.features_section}>
                <div className={styles.section_heading}><h3>Best Features of Billing Software for Amusement Parks</h3><div className={styles.heading_stroke} style={{ width: '12rem' }}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div></div>
                <OutletFeatures features={features.slice(0, 3)} setDemoModal={setDemoModal} setHeading={setHeading} mobileView={Boolean(mobileView)} />
            </div>
            <div >
                <DownloadBrochureWonderla mobileView={Boolean(mobileView)} />
            </div>
            <div className={styles.features_section}>
                <OutletFeatures features={features.slice(3)} setDemoModal={setDemoModal} setHeading={setHeading} mobileView={Boolean(mobileView)} />
            </div>
            <div><ParksFeaturesSection data={parksFeatures}/></div>
            <div className={styles.features_section}>
               <div className={styles.section_heading}><h3>The QueueBuster Experience</h3><div className={styles.heading_stroke} style={{ width: '12rem' }}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div></div>
                <QueueBusterExperienceCentersSection mobileView={Boolean(mobileView)} />
            </div>

            <div className={styles.three_step_form}>
                <ThreeStepForm mobileView={mobileView} />
            </div>

            {/* <div className={styles.testimonial_section}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div> */}
            <div><ThemeParkReviewsSection /></div>

            <div style={{ marginTop: "6rem" }}>
                {
                    mobileView ?
                        <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"FAQs for Amusement park POS Software"} />
                        :
                        <FrequentQuestions FaqTableData={faqs} heading={"FAQs for Amusement park POS Software"} />
                }
            </div>

            <div className={styles.demo_banner_section}>
                {
                    mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
                }
            </div>
        </div>
    )
}

export default ThemePark
